import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-error-403',
  templateUrl: './error-403.component.html',
})
export class Error403Component {}
